var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowerPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1907_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8161 31.9247C52.3548 8.85844 26.8952 8.85844 36.4339 31.9247C26.8952 8.85844 8.85844 26.8952 31.9247 36.4339C8.85844 26.8952 8.85844 52.3548 31.9247 42.8161C8.85844 52.3895 26.8605 70.3916 36.4339 47.3253C26.8605 70.3916 52.3548 70.3916 42.8161 47.3253C52.3895 70.3916 70.3916 52.3895 47.3253 42.8161C70.3916 52.3895 70.3916 26.8952 47.3253 36.4339C70.3916 26.8952 52.3548 8.85844 42.8161 31.9247Z",
    fill: "#EA86AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6381 42.123L32.2122 43.5088C26.54 45.863 23.5122 48.6878 22.2157 51.1523C20.9236 53.6086 21.3489 55.6594 22.4698 56.7802C23.5906 57.9011 25.6414 58.3264 28.0977 57.0343C30.5622 55.7379 33.387 52.71 35.7412 47.0378L36.4339 47.3253L37.1266 47.6128C34.7724 53.2849 34.6254 57.4206 35.45 60.0778C36.2717 62.7256 38.0236 63.875 39.612 63.875C41.2007 63.875 42.9549 62.7252 43.7808 60.0768C44.6095 57.4194 44.4686 53.2838 42.123 47.6119L43.5088 47.0378C45.863 52.71 48.6878 55.7379 51.1523 57.0343C53.6086 58.3264 55.6594 57.9011 56.7802 56.7802C57.9011 55.6594 58.3264 53.6086 57.0343 51.1523C55.7379 48.6878 52.71 45.863 47.0378 43.5088L47.3253 42.8161L47.6128 42.1234C53.2849 44.4776 57.4206 44.6246 60.0778 43.8C62.7256 42.9783 63.875 41.2264 63.875 39.638C63.875 38.0493 62.7252 36.2951 60.0768 35.4692C57.4194 34.6405 53.2838 34.7814 47.6119 37.127L47.3253 36.4339L47.0387 35.7408C52.7106 33.3953 55.7357 30.5749 57.0293 28.1127C58.3182 25.6592 57.8911 23.6067 56.7672 22.4828C55.6433 21.3589 53.5909 20.9318 51.1373 22.2207C48.6751 23.5143 45.8547 26.5394 43.5092 32.2113L42.8161 31.9247L42.123 31.6381C44.4686 25.966 44.6117 21.8302 43.7855 19.1726C42.962 16.524 41.2109 15.375 39.625 15.375C38.0391 15.375 36.288 16.524 35.4645 19.1726C34.6383 21.8302 34.7814 25.966 37.127 31.6381L36.4339 31.9247L35.7408 32.2113C33.3953 26.5394 30.5749 23.5143 28.1127 22.2207C25.6592 20.9318 23.6067 21.3589 22.4828 22.4828C21.3589 23.6067 20.9318 25.6592 22.2207 28.1127C23.5143 30.5749 26.5394 33.3953 32.2113 35.7408L31.9247 36.4339L31.6381 37.127C25.966 34.7814 21.8302 34.6383 19.1726 35.4645C16.524 36.288 15.375 38.0391 15.375 39.625C15.375 41.2109 16.524 42.962 19.1726 43.7855C21.8301 44.6117 25.9655 44.4686 31.637 42.1235L31.6381 42.123ZM31.6381 42.123C31.6378 42.1232 31.6375 42.1233 31.6372 42.1234L31.6381 42.123Z",
    stroke: "#1C1616",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1907_1893",
    x: 14.625,
    y: 14.625,
    width: 50,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1907_1893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1907_1893",
    result: "effect2_dropShadow_1907_1893"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1907_1893",
    result: "effect3_dropShadow_1907_1893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_1907_1893",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerPink);
export default __webpack_public_path__ + "static/media/flower-pink.e6b08e6a.svg";
export { ForwardRef as ReactComponent };